/** Continue URL embedded in passwordless email links (Firebase / BFF). */

export function resolvePasswordlessEmailContinueUrl(email?: string): string {
  if (typeof window === 'undefined') {
    return '';
  }
  const url = new URL(`${window.location.origin}/login`);
  const normalized = email?.trim().toLowerCase();
  if (normalized) {
    url.searchParams.set('heEmail', normalized);
  }
  return url.toString();
}
